// Co-living sends its alerts to the Chatwoot bell as agent notifications whose
// primary actor is the Account, not a conversation (a message failed, a
// ticket needs an admin, an offer expired...). The bell, the notifications
// page and the inbox list all assume a conversation, so a click opened the
// wrong one. These helpers recognise such a notification, show its own words
// and open the ticket it is about.
//
// singabot adds `meta.module = 'co_living'` and `meta.ticket_id` when the
// alert belongs to a ticket. Older ones have neither.

export const isCoLivingTicketNotification = notification =>
  notification?.meta?.module === 'co_living' && !!notification.meta.ticket_id;

// Agent notifications about the account itself (singabot's other features
// send these too, so on their own they prove nothing).
const isAccountAlert = notification =>
  notification?.notification_type === 'notify_agent' &&
  notification?.primary_actor_type === 'Account';

// The title and the line under it, in the notification's own words, for the
// rows that are not about a conversation. Empty for every other row.
export const coLivingNotificationTitle = notification =>
  isCoLivingTicketNotification(notification) ||
  (isAccountAlert(notification) && notification.meta?.title)
    ? notification.meta.title || ''
    : '';

export const coLivingNotificationBody = notification =>
  coLivingNotificationTitle(notification) ? notification.meta.body || '' : '';

// Where a click should go, or null when it is an ordinary conversation
// notification. A ticket alert opens its ticket; an older co-living alert
// (no ticket id) opens the tickets list, but only on an account that runs
// co-living, since other features send account alerts too.
export function coLivingNotificationRoute(notification, store, accountId) {
  if (isCoLivingTicketNotification(notification)) {
    return {
      name: 'co_living_ticket',
      params: { accountId, ticketId: notification.meta.ticket_id },
    };
  }
  if (
    isAccountAlert(notification) &&
    store.getters['stripe/getModuleName'] === 'co_living'
  ) {
    return { name: 'co_living_tickets', params: { accountId } };
  }
  return null;
}

// Marks the notification read, as the conversation handlers do.
export function markNotificationRead(store, notification, unreadCount) {
  store.dispatch('notifications/read', {
    id: notification.id,
    primaryActorId: notification.primary_actor_id,
    primaryActorType: notification.primary_actor_type,
    unreadCount,
  });
}
